const NBSP = '\u00A0';

/**
 * Расстояние в карточке: метры до километра, дальше — километры с одним знаком.
 * Используется и для метро, и для чипа «Рядом со мной».
 */
export function formatDistanceKm(distanceKm: number): string {
    if (distanceKm < 1) {
        return `${Math.round(distanceKm * 1000)}${NBSP}м`;
    }

    return `${distanceKm.toFixed(1).replace('.', ',')}${NBSP}км`;
}
